<template>
  <section>
    <div>
      <AdvanceRequisitesListReadonly
        v-if="value && value.length"
        :value="value"
        :level="1"
      />
      <div
        v-else
        class="p-3 text-muted bg-light rounded-5 text-center border"
      >No Requirement Added</div>
    </div>
  </section>
</template>

<script>
import AdvanceRequisitesListReadonly from './AdvanceRequisitesListReadonly'

export default {
  components: {
    AdvanceRequisitesListReadonly,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
}
</script>
